import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ActiveCartFacade, Cart } from "@spartacus/cart/base/root";
import { map } from "rxjs/operators";
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';

@Injectable({
  providedIn: 'root'
})
export class GenCartSppFormValidatedGuard implements CanActivate {
  constructor(
    private activeCartFacade: ActiveCartFacade,
    private router: Router,
    private globalMessageService: GlobalMessageService,
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.activeCartFacade.takeActive()
      .pipe(
        map((cart) => {
          if (!this.isEmpty(cart) && !cart.sppFormIncomplete) {
            return true;
          }
          this.router.navigate(['/cart'], {
            queryParams: { expandSppForm: true },
          });
          this.globalMessageService.add(
            {
              key: 'httpHandlers.sppFormValidationErrorMessage'
            },
            GlobalMessageType.MSG_TYPE_ERROR)
          return false;
        })
      )
  }

  private isEmpty(cart: Cart): boolean {
    return cart && !cart.totalItems;
  }

}
